(function () {

  'use strict';

  function pxSubscriptionHistory(
    $http, $window, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        billingData: '='
      },
      templateUrl: 'app/components/subscription/history/history.template.html',
      link: function (scope) {

        scope.columnNames = {
          // Id: 'INVOICE_NUMBER',
          Period: 'START_TIME'
          // PrintixUsers: 'ACTIVE_USERS',
          // PowerPdfMacUsers: 'POWER_PDF_USERS_MAC',
          // PowerPdfWindowsUsers: 'POWER_PDF_USERS_WIN'
        };

        scope.directions = {
          Ascending: 'ASC',
          Descending: 'DESC'
        };

        scope.paging = {
          pagingCriteria: {
            page: 0,
            pageSize: 12,
            sort: scope.columnNames.Period,
            direction: scope.directions.Descending,
            reduced: true
          }
        };

        scope.totalPages = 0;

        scope.loading = false;
        scope.invoices = [];

        scope.isPrintixEnabled = TenantListService.currentTenant.isPrintixEnabled();
        scope.isPowerPdfEnabled = TenantListService.currentTenant.isPowerPDFEnabled();

        scope.columnCount = 3 + (scope.isPrintixEnabled ? 1 : 0) + (scope.isPowerPdfEnabled ? 2 : 0);

        scope.getDataSortValue = function (columnName) {
          if (scope.paging.pagingCriteria.sort === columnName) {
            // For historical reasons, this actually returns the opposite value.
            return scope.paging.pagingCriteria.direction === scope.directions.Ascending ? 'desc' : 'asc';
          }
          return undefined;
        };

        scope.openInvoice = function (invoice) {
          $http.get(invoice._links['px:invoicePdf'].href, { responseType: 'arraybuffer' })
            .then(function (result) {
              const file = new Blob([result.data], { type: 'application/pdf' });
              if ($window.navigator?.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(file);
              } else {
                const windowReference = $window.open();
                windowReference.location = URL.createObjectURL(file);
              }
            })
            .catch(function () {
            });
        };

        scope.changeOrderByColumn = function (columnName) {
          if (scope.paging.pagingCriteria.sort === columnName) {
            scope.paging.pagingCriteria.direction = scope.paging.pagingCriteria.direction === scope.directions.Ascending ? scope.directions.Descending : scope.directions.Ascending;
          } else {
            scope.paging.pagingCriteria.sort = columnName;
            scope.paging.pagingCriteria.direction = scope.directions.Ascending;
          }
          scope.getPageOfInvoices();
        };

        scope.getPageOfInvoices = function () {
          scope.loading = true;
          const url = scope.billingData._links['px:periods'].href;
          $http.get(url, { params: scope.paging.pagingCriteria })
            .then(function (response) {
              scope.invoices = response.data._embedded['px:billingPeriodResources'];
              scope.paging.pagingCriteria.page = response.data.page.number;
              scope.totalPages = response.data.page.totalPages;
              scope.loading = false;
            })
            .catch(function () {
              scope.loading = false;
            });
        };

        (function () {
          scope.getPageOfInvoices();
        })();

      }
    };
  }

  pxSubscriptionHistory.$inject = ['$http', '$window', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxSubscriptionHistory', pxSubscriptionHistory);

})();
